import React from 'react';

const DiamondIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M13.5 3H4.5L0.75 7.125L9 15.75L17.25 7.125L13.5 3ZM10.2 9.45L9 12.375L7.8 9.45L4.875 8.25L7.8 7.05L9 4.125L10.2 7.05L13.125 8.25L10.2 9.45Z" fill="url(#paint0_linear_15450_181)" />
      <defs>
        <linearGradient id="paint0_linear_15450_181" x1="1.1625" y1="3.26562" x2="12.2364" y2="19.1529" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7A96AC" />
          <stop offset="0.18" stopColor="#EAEFF3" />
          <stop offset="0.315" stopColor="#C2D4E1" />
          <stop offset="0.491919" stopColor="white" />
          <stop offset="0.615" stopColor="#D4DEE5" />
          <stop offset="0.785" stopColor="#ABBDC8" />
          <stop offset="0.955" stopColor="#BCCAD7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DiamondIcon;